import { defineSagaForService, DownloadQueriesSagasFactory, QueriesSagasFactory } from '@repo/core'
import { all, takeLatest } from 'redux-saga/effects'
import {
  fileDownloadConfig as fileDownloadConfigMaster,
  serviceConfig as serviceConfigMaster,
} from './master'
import { watchPositionNotifications } from './notifications'

const serviceConfig = defineSagaForService({ ...serviceConfigMaster })
const fileDownloadConfig = { ...fileDownloadConfigMaster }

const serviceSagas = Object.keys(serviceConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, QueriesSagasFactory(serviceConfig, actionTypeRequest)),
)

const fileDownloadSagas = Object.keys(fileDownloadConfig).map((actionTypeRequest) =>
  takeLatest(actionTypeRequest, DownloadQueriesSagasFactory(fileDownloadConfig, actionTypeRequest)),
)

export function* rootPositionSaga() {
  yield all([...serviceSagas, ...fileDownloadSagas, watchPositionNotifications()])
}
